import type { RouteRecordRaw } from "vue-router"

const cart = [
  {
    path: "/cart",
    name: "/cart",
    // @ts-ignore
    component: () => import("@/views/CartPage.vue"),
    meta: {
      availableInIframe: true,
      requiresAuth: false,
      layout: "Main",
      title: "Cart",
    },
  },
  {
    path: "/cart/checkout",
    name: "/cart/checkout",
    component: () => import("@/views/CartWorkshopPageCheckout.vue"),
    meta: {
      availableInIframe: true,
      requiresAuth: false,
      layout: "Main",
      title: "Cart Checkout",
    },
      beforeEnter: () => {
        if (typeof window !== "undefined") {
          //@ts-ignore
          window.dataLayer = window.dataLayer || [];
          //@ts-ignore
          window.dataLayer.push({
            event: 'begin_checkout',
          });
        }
      }
    },
] as RouteRecordRaw[]

export { cart }
